export const closeCreateSkillDialogReducer = (state) => {
    state.createSkillDialog.isOpen = false;
    state.createNewSkill.status = "idle";
    state.createNewSkill.errorMessage = "";
}
